/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsListVersions } from "../../funcs/llmSkillsListVersions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListSkillVersionsRequest$inboundSchema,
};

export const tool$llmSkillsListVersions: ToolDefinition<typeof args> = {
  name: "llm-skills-list-versions",
  description: `List skill versions

Returns a paginated list of versions for a skill.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsListVersions(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
